// John Eldhose 20180511
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import { getLanguage } from '../Api/getLanguage';
import Layout from './Layout';

class AppRender extends Component {

  state = {
    language: 'en_US'
  }
  messages = {};
  handleLanguageChange = (language) => {
    getLanguage(language)
      .then((lang) => {
        this.messages[language] = lang['data'];
        this.setState({ language: language });
      })
      .catch((error) => {
        console.log('Error cannot download Language: ' + error);
        return 'en_US';
      })
  }
  componentWillMount() {
    this.handleLanguageChange('en_US');
  }

  render() {
    if(this.state.language !== this.props.LanguageSelected)
      this.handleLanguageChange(this.props.LanguageSelected);
    return (
      <div>
        <IntlProvider
          locale='en'
          messages={this.messages[this.state.language]}
        >
          <Layout />
        </IntlProvider>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return ({ LanguageSelected: state.LanguageSelected });
}

const LanguageSelected = connect(
  mapStateToProps,
  null
)(AppRender);

export default LanguageSelected;



// WEBPACK FOOTER //
// ./src/components/LanguageSelected.js